import 'polyfills';

import ReactOnRails from 'react-on-rails';

import View from '../components/Builder/View';
import FeatureFlagAlert from '../components/FeatureFlag/FeatureFlagAlert';
import Footer from '../components/OC/footer';
import { ProvidedMegaNav as MegaNav } from '../components/OC/meganav';
import RichText from '../components/OC/oc-rich-text';
import Text from '../components/OC/oc-text';
import warrantyStandardStore from '../components/Warranty/WarrantyStandardForm/redux/store';
import WarrantyStandardForm from '../components/Warranty/WarrantyStandardForm/warranty-standard-form.jsx';
import CrossingLocale from '../components/location/CrossingLocale';
import Switcher from '../components/location/Switcher';

ReactOnRails.registerStore({
  warrantyStandardStore,
});

ReactOnRails.register({
  WarrantyStandardForm: WarrantyStandardForm,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': CrossingLocale,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Builder::View': View,
  'OC::Text': Text,
  'OC::Footer': Footer,
  'OC::Richtext': RichText,
  MegaNav,
});
